module.exports = __webpack_public_path__ + "static/img/viral_27.468c9fdf.jpg";